import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import DateTimeDisplay from './DateTimeDisplay';
import axios from '../lib/axios';
import 'react-simple-dropdown/styles/Dropdown.css';

class DropdownUpcomingEvents extends Component {
  static propTypes = {
    apiUrl: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.dropdown = React.createRef();
    this.state = {
      open: false,
      items: [],
    };
  }

  componentDidMount() {
    axios.get(this.props.apiUrl).then((response) => {
      this.setState({
        open: this.dropdown.current.isActive(),
        items: Object.values(response.data.items).reduce((acc, item) => {
          if (item.type === 'OfficeHour' && !item.isHosting && item.slots !== null) {
            item.slots
              .filter((slot) => slot.isAttending)
              .forEach((slot) => {
                acc.push(
                  Object.assign({}, item, { start_date: slot.start_date, end_date: slot.end_date })
                );
              });
          } else {
            acc.push(item);
          }
          return acc;
        }, []),
      });
    });
  }

  onShow = () => {
    this.setState({ open: true });
  };

  onHide = () => {
    this.setState({ open: false });
  };

  hide = () => {
    this.dropdown.current.hide();
  };

  renderItem = (item) => {
    const { id, url, title, label, start_date, end_date } = item;
    const type = label.replace(/\s+/g, '-').toLowerCase();
    return (
      <li
        key={id}
        className="u-flex u-flex-col u-border u-border-grey-lighter u-rounded u-mt-3 u-mx-3 u-p-2 md:u-max-w-xs">
        <a href={url} className="u-font-bold u-whitespace-normal">
          {title}
        </a>
        <div className="u-flex u-items-center u-text-xs">
          <i className="Icon Icon-calendar u-mr-2 u-mb-1" />
          <DateTimeDisplay timestamp={start_date} format={'MMM D YYYY, h:mm A'} />
          <span className="u-mx-1">-</span>
          <DateTimeDisplay timestamp={end_date} format={'h:mm A z'} />
        </div>
        <div className={`u-text-color-${type} u-text-xs`}>{label}</div>
      </li>
    );
  };

  render() {
    const classNames = ['u-fixed u-bg-black u-w-full u-h-full u-inset-0 u-opacity-30 lg:u-hidden'];
    if (this.state.open) {
      classNames.push('u-block');
    } else {
      classNames.push('u-hidden');
    }

    return (
      <Dropdown
        className="u-relative"
        ref={this.dropdown}
        onShow={this.onShow}
        onHide={this.onHide}>
        <DropdownTrigger>
          <div className="u-mr-3 md:u-mr-4 u-relative">
            <i className="Icon Icon-calendar u-cursor-pointer u-text-xl md:u-text-md u-relative u-text-grey-dark" />
            {this.state.items.length > 0 && (
              <span className="badge-indicator">{this.state.items.length}</span>
            )}
          </div>
        </DropdownTrigger>
        <div className={classNames.join(' ')} onClick={this.hide} />
        <DropdownContent
          className={`dropdown-content dropdown-upcoming-events animated bounceIn u-text-black`}>
          <ul className={`u-m-0 u-pb-3`}>
            {this.state.items.length === 0 && (
              <li key="no-results" className="u-text-sm u-mt-3 u-mx-3 u-p-2">
                There are no events on your upcoming schedule
              </li>
            )}
            {this.state.items.length > 0 && this.state.items.map(this.renderItem)}
          </ul>
        </DropdownContent>
      </Dropdown>
    );
  }
}

export default DropdownUpcomingEvents;
